// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1GJ3u","header":"PatientBlock_header__1WNyk","label":"PatientBlock_label__2LOL3","option":"PatientBlock_option__1WqSA"};